import { handleAction } from 'redux-actions';

import * as Actions from 'flex/Actions';

const defaultState = {
    payload: {},
    meta: {
        fetch: false,
        status: '',
        viewName: '',
    },
};

const defaultReducer = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    next: (_: any, action: any) => {
        return { ...action };
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    throw: (_: any, action: any) => {
        return Object.assign(action, {
            meta: {
                fetch: false,
                status: Actions.statusEnum.FAILURE,
            },
        });
    },
};

export const tenantSettingControlCreateConnection = handleAction(
    Actions.http.connection.tenantSetting.controlCreate,
    defaultReducer,
    defaultState,
);

export const tenantSettingControlViewConnection = handleAction(
    Actions.http.connection.tenantSetting.controlView,
    defaultReducer,
    defaultState,
);

export const tenantSettingViewConnection = handleAction(
    Actions.http.connection.tenantSetting.view,
    defaultReducer,
    defaultState,
);
